var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5796_52164)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6518 26.6329H51.3314V16.1502C51.2926 15.9305 51.2594 15.7096 51.2261 15.4889V15.4889C51.1532 15.0044 51.0804 14.521 50.9495 14.0538C49.5678 9.11556 46.3521 6.07402 41.3646 4.90645C41.047 4.8323 40.7231 4.7837 40.3992 4.7351C40.2453 4.71201 40.0914 4.68892 39.9382 4.66309H38.0241C37.9639 4.67655 37.9033 4.68786 37.8426 4.69916C37.7555 4.71542 37.6684 4.73165 37.583 4.75423C37.2184 4.85035 36.8464 4.93077 36.4743 5.0112C35.6537 5.18857 34.8327 5.36603 34.0903 5.71217C29.2422 7.97077 26.7412 11.8363 26.64 17.1911C26.601 19.2516 26.611 21.3133 26.621 23.3749V23.375V23.3751V23.3753V23.3754C26.6255 24.3057 26.63 25.2361 26.63 26.1662C26.63 26.2624 26.6358 26.3583 26.6422 26.4619L26.6422 26.462C26.6455 26.5164 26.649 26.573 26.6518 26.6329ZM37.2894 51.1765C37.566 51.2275 37.8426 51.2785 38.1182 51.3332H39.9411C40.1536 51.2937 40.3676 51.2594 40.5816 51.2251L40.5818 51.2251L40.582 51.2251L40.5821 51.225C41.0401 51.1516 41.4984 51.0782 41.9418 50.954C46.8974 49.5604 49.9417 46.3375 51.0965 41.3244C51.1728 40.9915 51.22 40.652 51.2671 40.3127C51.2886 40.1578 51.3101 40.003 51.3344 39.8488V29.367H28.7083C32.8682 35.1201 33.1863 41.02 29.7611 47.1514C31.0471 48.7182 33.3723 50.2504 35.3656 50.7726C35.9985 50.9385 36.6438 51.0575 37.2892 51.1764L37.2894 51.1765ZM4.77347 37.4612L4.77348 37.4611C4.84999 36.9776 4.92652 36.4939 5.04323 36.0202C5.49896 34.1727 6.24909 32.6815 7.31276 31.3654L24.6305 48.6831C23.5406 49.5849 22.2833 50.2626 20.9309 50.6774C20.2872 50.8717 19.6237 51.0069 18.9621 51.1418C18.6615 51.2031 18.3612 51.2643 18.0634 51.3309H16.0582C15.8446 51.2916 15.6298 51.2572 15.4149 51.2229C14.9567 51.1496 14.4985 51.0764 14.053 50.9554C9.52305 49.7231 6.54896 46.8538 5.16081 42.3722C4.99484 41.8351 4.89966 41.2764 4.80445 40.7175C4.76006 40.4569 4.71565 40.1962 4.66406 39.9377L4.66589 38.1166C4.70422 37.8988 4.73884 37.68 4.77347 37.4612ZM9.37175 29.3231L26.6894 46.6281C30.6288 41.6871 30.0947 34.3298 25.5656 30.0724C20.6319 25.4303 13.4888 25.8377 9.37175 29.3231Z",
    fill: "url(#paint0_linear_5796_52164)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5796_52164",
    x1: 51.3344,
    y1: 4.66309,
    x2: 4.66429,
    y2: 51.3334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#56B8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F8FB9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5796_52164"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPill);
export default __webpack_public_path__ + "static/media/icon-pill.0d44860cccb056df1f02b1ecca1216a0.svg";
export { ForwardRef as ReactComponent };